export default __webpack_public_path__ + "assets/images/580e3a11b8d9a387ab542f3a67eac2b8.webp";